import React from 'react'
import styles from './authlayout.module.scss'

const AuthLayout = ({ children }) => {
    return (
        <div className={styles.body} >

            <div className={styles.formcont} >
                <main>
                    {children}
                </main>
            </div>

        </div>
    )
}

export default AuthLayout